import { CircularProgress, IconButton, IconButtonProps } from '@mui/material';
import * as React from 'react';
import { forwardRef } from 'react';
import { ButtonProps } from 'react-admin';

const LoadingIconButton = forwardRef(({
                                          loading,
                                          children,
                                          ...props
                                      }: IconButtonProps & {
    download?: string;
    href?: string;
    loading?: boolean;
}, ref) => {

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    return (
        // @ts-ignore
        <IconButton {...props} ref={ref}>
            {loading ? (
                <CircularProgress
                    sx={{ width: 24, mx: 'auto' }}
                    color={'primary'}
                    size={'small'}
                />
            ) : (
                children
            )}
        </IconButton>
    );
});

export default LoadingIconButton;
